import { useTranslation } from 'react-i18next';

import { AddBeneficiary } from '@/features/beneficiaries/components/AddBeneficiary/AddBeneficiary';
import { AllBeneficiariesTable } from '@/features/beneficiaries/components/AllBeneficiaries/AllBeneficiariesTable';
import { useUserBeneficiariesData } from '@/features/beneficiaries/hooks/AllBeneficiaries/useUserBeneficiariesData';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAction } from '@/hooks/useAction';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

export function AllUserBeneficiaries() {
  const { t } = useTranslation();

  const { hasAccessToFeature } = useAccesControl();
  const { displayActionFromConfig } = useAction();

  const props = useUserBeneficiariesData();

  return (
    <div className="flex flex-col mt-6 gap-5">
      <div className="flex items-center justify-between">
        <h4 className="typo-h4-bold text-secondary">{t('pages.currentProfiles.profile.tabs.title.beneficiaries')}</h4>
        {hasAccessToFeature(featuresSlugs.CREATE_BENEFICIARY) && displayActionFromConfig('addBeneficiary') && (
          <AddBeneficiary />
        )}
      </div>
      <AllBeneficiariesTable {...props} className="h-[calc(100vh-480px)] lightScrollBar" />
    </div>
  );
}
